import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function PageTransition({ targetRoute = "/", logo = "/vodafone-logo.png", delay = 1500 }) {
  const navigate = useNavigate();
  const [show, setShow] = useState(true);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShow(false);
      setTimeout(() => navigate(targetRoute), 300); // warte kurz bis fade-out fertig
    }, delay);

    return () => clearTimeout(timeout);
  }, [navigate, delay, targetRoute]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          key="transition"
          initial={{ opacity: 1 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
          style={{
            position: "fixed",
            zIndex: 2000,
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "#ffffff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <img
            src={logo}
            alt="Logo"
            style={{ width: 120, height: 120, marginBottom: 20 }}
          />
          <Typography variant="h6" color="textSecondary">
            Weiterleitung…
          </Typography>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
